export default {
      id: "rotor-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "img/icons.68fd9e19.svg#rotor",
      toString: function () {
        return this.url;
      }
    }